import Template7 from "template7";
import bn from "./_/build-number";
import vn from "./_/version-number";
window.appVersionLabel = vn;
window.buildNumber = bn;
window.host = "https://api.mitsulift.local";
// window.host = "https://api.mitsulift.codendot.co";
//window.host = "https://user.app.mitsulift.com";

window.cordovaHost = "https://user.app.mitsulift.com";
// window.cordovaHost = "https://api.mitsulift.codendot.co";

window.registrationId = null;

window.language = "en-US";
window.api_version = "v1";

window.loggedIn = localStorage.getItem("loggedIn");
//console.log(window.loggedIn);

window.identity = localStorage.getItem("identity");
if (window.identity) {
    window.identity = JSON.parse(window.identity);
}
//console.log(window.identity);

window.countries = {
    lb: 'Lebanon',
    ng: 'Nigeria',
    gh: 'Ghana',
    jo: 'Jordan',
    cy: 'Cyprus',
    gr: 'Greece',
    mt: 'Malta',
    ci: 'Ivory Coast',
    sy: 'Syria',
    iq: 'Iraq',
    ot: 'Other',
};
window.country = localStorage.getItem("country");
if (!window.country || !window.loggedIn) {
    window.country = "lb";
    // var cntr = window.getCountry();
    // if(window.countries[cntr.toLowerCase()]){
    //     window.country = cntr.toLowerCase();
    // }
    localStorage.setItem("country", window.country);
}

window.User = {
    logIn: function (data) {
        window.loggedIn = true;
        window.identity = data;
        localStorage.setItem("loggedIn", true);
        localStorage.setItem("identity", JSON.stringify(data));
    },
    logOut: function () {
        window.loggedIn = false;
        window.identity = null;
        localStorage.removeItem("loggedIn");
        localStorage.removeItem("identity");
        //console.log("user logged out");
    }
};

//<editor-fold defaultstate="collapsed" desc="Url">
window.Url = {
    to: function (endpoint) {
        return window.host + "/" + window.language + "/" + window.api_version + "/" + endpoint;
    }
};
//</editor-fold>

//This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
window.calcCrow = function (lat1, lon1, lat2, lon2) {
    console.log("CURRENT", lat1, lon1, "LOCATION", lat2, lon2);
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
}
// Converts numeric degrees to radians
window.toRad = function (Value) {
    return Value * Math.PI / 180;
}
window.okv = function(obj, key){
    console.log(obj, key)
    return obj[key];
}

window.editionTranslations = {};
window.translate = function (key) {
    return window.editionTranslations?.[key] || key;
};
Template7.registerHelper('translate', window.translate);
